import { motion } from "framer-motion";
import { MANIFESTO } from "@/data/site";

export default function Manifesto({ compact = false }) {
  return (
    <section data-testid="manifesto" className="relative bg-[#0d1c40] text-white overflow-hidden py-8">
      <div className="pointer-events-none absolute -left-32 top-1/4 h-96 w-96 rounded-full bg-[#2FA86A]/10 blur-3xl" />
      <div className="nc-container relative">
        {!compact && (
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.2em] text-[#2FA86A]">
              <span className="h-px w-8 bg-[#2FA86A]" />
              Why North Cadence
            </span>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.12]">
              What we believe about growth and the people behind it.
            </h2>
          </div>
        )}

        <div className={`${compact ? "mt-0" : "mt-16"} divide-y divide-white/10 border-y border-white/10`}>
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.n}
              data-testid={`manifesto-${m.n}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              className="group grid gap-6 py-10 md:grid-cols-[auto_1fr_1.4fr] md:items-baseline md:gap-12"
            >
              <span className="font-display text-6xl md:text-7xl font-extrabold text-white/10 transition-colors duration-500 group-hover:text-[#2FA86A]/40">
                {m.n}
              </span>
              <h3 className="font-display text-2xl md:text-3xl font-bold leading-tight">{m.title}</h3>
              <p className="text-lg leading-relaxed text-white/60">{m.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
